import intl from 'react-intl-universal';
import { useEffect, useState, useRef } from 'react';
// import E from 'wangeditor';
import { useModel } from '@umijs/max';
import { Editor as WangeEditor, Toolbar } from '@wangeditor/editor-for-react';
import { IDomEditor, IToolbarConfig } from '@wangeditor/editor';
// import { getOSSPolicy } from '@/api/common';
import getOSSFileName from '@/utils/getOSSFileName';
import { fileCDN, isGlobalEnv } from '@/config';
import { upload } from '@/utils/fetch';
import type { ProFormProps } from '@ant-design/pro-components';
import { OSSAssetsType } from '@/type/common';
import { commonRules } from '@/commonConfig/index';
import '@wangeditor/editor/dist/css/style.css';
import style from './index.less';
import Annex from '@/components/Annex/index';

type InsertFnType = (url: string) => void;

interface Props extends ProFormProps {
    value: string;
    onChange: (value: string) => void;
    // onClick?: (value: any) => void;
    name?: string;
    placeholder?: string;
    readonly?: boolean;
}

interface FileItem extends File {
    fileName: string;
    url: string;
}

const Editor: React.FC<Props> = (props) => {
    const { placeholder, readonly, value } = props;
    const {
        OSSData: originOssData,
        getOSSAssets,
        GCSToken: originGCSToken,
        getGCSToken,
    } = useModel('formData');
    const OSSData = useRef<OSSAssetsType>();
    const GCSToken = useRef<string>();
    const [editor, setEditor] = useState<IDomEditor | null>();
    const [urls, setUrls] = useState<string>('');
    useEffect(() => {
        if ((isGlobalEnv && !GCSToken) || !OSSData) {
            if (isGlobalEnv) {
                getGCSToken();
            } else {
                getOSSAssets();
            }
        }

        return () => {
            editor && editor.destroy();
            setEditor(null);
        };
    }, []);

    useEffect(() => {
        console.log(GCSToken);
        OSSData.current = originOssData;
        GCSToken.current = originGCSToken;
    }, [originOssData, originGCSToken]);

    useEffect(() => {
        if (editor) {
            editor.destroy();
            setEditor(null);
        }
    }, [placeholder]);
    // useEffect(() => {
    //     if (editor) {
    //         console.log(editor.getAllMenuKeys());
    //     }
    // }, [editor]);

    // const getOSSAssets = async () => {
    //     const result = await getOSSPolicy();
    //     if (result) {
    //         OSSData.current = result;
    //     }
    // };

    const getExtraData: (file: FileItem) => { [key: string]: any } = (
        file,
    ) => ({
        key: file.fileName,
        OSSAccessKeyId: OSSData.current?.ossAccessKeyId,
        policy: OSSData.current?.policy,
        Signature: OSSData.current?.signature,
    });

    const onChange = (e: any) => {
        const html = e.getHtml();
        if (e?.isEmpty()) {
            props.onChange(undefined);
        } else {
            props.onChange(html);
        }
    };

    const getPlaceholder = (placeholder?: string) => {
        if (!placeholder) return intl.get('请输入');
        const lines = placeholder.split(`\n`);
        return lines.map((line) => `<p>${line}</p>`).join('');
    };

    const toolbarConfig: Partial<IToolbarConfig> = {
        toolbarKeys: readonly
            ? []
            : [
                  'headerSelect', // 标题
                  'bold', // 粗体
                  'underline', // 下划线
                  'italic', // 斜体
                  'clearStyle',
                  //   '|',
                  'fontSize', // 字号
                  'lineHeight',
                  'color', // 字体颜色
                  'bgColor', // 背景色
                  {
                      key: 'group-more-justify', // 必填，要以 group 开头
                      title: intl.get('对齐方式'), // 必填
                      iconSvg:
                          '<svg t="1692261865142" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4007" xmlns:xlink="http://www.w3.org/1999/xlink" width="200" height="200"><path d="M112.786286 207.725714h797.988571c18.432 0 33.005714-14.153143 33.005714-32.585143 0-17.993143-14.573714-32.146286-32.987428-32.146285H112.786286c-18.432 0-32.566857 14.153143-32.566857 32.146285 0 18.432 14.134857 32.566857 32.548571 32.566858z m0 224.548572h797.988571c18.432 0 33.005714-14.134857 33.005714-32.548572 0-18.011429-14.573714-32.146286-32.987428-32.146285H112.786286c-18.432 0-32.566857 14.134857-32.566857 32.128 0 18.432 14.134857 32.585143 32.548571 32.585142z m0 224.585143h797.988571a32.658286 32.658286 0 0 0 33.005714-32.566858c0-18.011429-14.573714-32.146286-32.987428-32.146285H112.786286c-18.432 0-32.566857 14.134857-32.566857 32.146285 0 17.993143 14.134857 32.548571 32.548571 32.548572z m0 224.146285h797.988571c18.432 0 33.005714-14.153143 33.005714-32.146285s-14.573714-32.566857-32.987428-32.566858H112.786286a32.292571 32.292571 0 0 0-32.566857 32.548572c0 18.011429 14.134857 32.164571 32.548571 32.164571z" p-id="4008"></path></svg>', // 可选
                      menuKeys: [
                          'justifyLeft',
                          'justifyRight',
                          'justifyCenter',
                          'justifyJustify',
                      ],
                      // 下级菜单 key ，必填
                  },
                  //   '|',
                  'insertLink',

                  'insertTable',
                  'code',
                  'insertImage',
                  'uploadImage',
                  //   '|',
                  'redo',
                  'undo',
                  'fullScreen',
              ],
    };

    const getEditorConfig = () => {
        return {
            MENU_CONF: {
                uploadImage: {
                    maxFileSize: commonRules.maxFileSize * 1024 * 1024,
                    base64LimitSize: true,
                    customUpload: (file: any, insertImgFn: InsertFnType) => {
                        file.fileName = `${
                            OSSData.current?.dir
                        }${getOSSFileName(file.name)}`;

                        const { action } = OSSData.current || {};

                        console.log(
                            '-=-=-=customUpload',
                            action,
                            GCSToken.current,
                        );

                        if (action || GCSToken.current) {
                            upload({
                                method: 'post',
                                action: isGlobalEnv
                                    ? `https://storage.googleapis.com/upload/storage/v1/b/service-center-work-order/o?uploadType=media&name=image/${file.name}`
                                    : action,
                                filename: name,
                                data: isGlobalEnv
                                    ? undefined
                                    : getExtraData(file),
                                file,
                                type: isGlobalEnv ? null : 'formData',
                                headers: isGlobalEnv
                                    ? {
                                          Authorization: `Bearer ${GCSToken.current}`,
                                      }
                                    : undefined,
                                withCredentials: false,
                                onProgress: (e: any) => {
                                    console.log(e);
                                },
                                onSuccess: (ret: any) => {
                                    console.log(ret);
                                    if (isGlobalEnv) {
                                        file.url = ret.mediaLink;
                                    } else {
                                        file.url = `${fileCDN}/${file.fileName}`;
                                    }
                                    insertImgFn(file.url);
                                },
                                onError: (err: any) => {
                                    console.log(err);
                                },
                            });
                        }
                    },
                },
            },
            placeholder: getPlaceholder(placeholder),
            readOnly: readonly,
            autoFocus: false,
        };
    };
    const richTextImgClick = (e: any) => {
        if (readonly) {
            if (e.target.tagName === 'IMG') {
                setUrls(e.target.src);
            }
            // onClick()
        }
    };

    return (
        <>
            {!readonly && (
                <Toolbar
                    style={{
                        border: '1px solid #ccc',
                        borderBottom: 'none',
                    }}
                    editor={editor}
                    defaultConfig={toolbarConfig}
                    mode="default"
                />
            )}
            <div onClick={richTextImgClick}>
                <WangeEditor
                    className={`${style.editor} ${
                        readonly && style.editor_readonly
                    }`}
                    defaultHtml={value}
                    onCreated={setEditor}
                    defaultConfig={getEditorConfig()}
                    onChange={onChange}
                ></WangeEditor>
            </div>
            <Annex
                src={urls}
                removeUrl={(val: string) => setUrls(val)}
            ></Annex>
        </>
    );
};

export default Editor;
